var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppTooRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3782_71873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3782_71873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3782_71873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 4C13.1043 4 13.9997 3.10457 13.9997 2C13.9997 0.89543 13.1043 0 11.9997 0C10.8952 0 9.99976 0.89543 9.99976 2C9.99976 3.10457 10.8952 4 11.9997 4Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 14.0003C13.1043 14.0003 13.9997 13.1049 13.9997 12.0003C13.9997 10.8957 13.1043 10.0003 11.9997 10.0003C10.8952 10.0003 9.99976 10.8957 9.99976 12.0003C9.99976 13.1049 10.8952 14.0003 11.9997 14.0003Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 23.9997C13.1043 23.9997 13.9997 23.1043 13.9997 21.9997C13.9997 20.8951 13.1043 19.9997 11.9997 19.9997C10.8952 19.9997 9.99976 20.8951 9.99976 21.9997C9.99976 23.1043 10.8952 23.9997 11.9997 23.9997Z",
    fill: "#374957"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3782_71873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppTooRight);
export default __webpack_public_path__ + "static/media/App-Too-Right.793dbcb76f95f9acbc591c198a742e4e.svg";
export { ForwardRef as ReactComponent };